(function () {
    function afDeletePwaLoadingScreenIfNotNecessary() {
        const pwaHelpScreen = document.getElementById("internal-amadeus-fire-loading-screen-pwa-helper");
        if(pwaHelpScreen && window.matchMedia('(display-mode: browser)').matches) {
            pwaHelpScreen.parentElement.removeChild(pwaHelpScreen);
        }
        if(pwaHelpScreen && sessionStorage.getItem("pwaHelpScreenLoaded")) {
            pwaHelpScreen.parentElement.removeChild(pwaHelpScreen);
        }
        else {
            sessionStorage.setItem("pwaHelpScreenLoaded","yes")
        }
        setTimeout(function() {
            document.querySelectorAll("main")[0].classList.add("internal-amadeus-fire-loading-screen-pwa-helper-deleted");
        },1000);
    }
    window.addEventListener('load',afDeletePwaLoadingScreenIfNotNecessary);
})();
